import { AfterContentInit, ChangeDetectorRef, Component, ContentChildren, QueryList, OnDestroy } from "@angular/core";
import { MultiviewContentDirective } from "./multiviewContent.directive";
import { Subscription } from "rxjs";

@Component({
    selector: 'multiview',
    templateUrl: './multiview.component.html',
    styleUrls: ['./multiview.component.css'],
    standalone: false
})
export class MultiviewComponent implements AfterContentInit, OnDestroy {
    @ContentChildren(MultiviewContentDirective) private contents: QueryList<MultiviewContentDirective>;

    private subscriptions: Subscription[];

    constructor(private changeDetector: ChangeDetectorRef) { }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.contents.forEach((x, index) => x.visible = index == 0);
        }, 0);

        this.subscriptions = this.contents.toArray().map(x => x.onVisibilityChanged.subscribe(event => {
            if (event.visibility) {
                this.contents.forEach(x => {
                    if (x != event.sender && x.visible) {
                        x.visible = false;
                    }
                });
            }
        }));
    }

    public get viewCount(): number {
        return this.contents.length;
    }

    public setView(viewIndex: number) {
        if (viewIndex > -1 && viewIndex < this.contents.length) {
            this.contents.toArray()[viewIndex].visible = true;
        }
    }

    public setViewWithContext(viewIndex: number, viewContext: any) {
        if (viewIndex > -1 && viewIndex < this.contents.length) {
            this.contents.toArray()[viewIndex].setVisibleWithContext(viewContext);
        }
    }

    public prev() {
        let contents = this.contents.toArray();

        let i = contents.findIndex(x => x.visible);

        if (i != -1 && i - 1 > -1) {
            contents[i - 1].visible = true;
        }
    }

    public next() {
        let contents = this.contents.toArray();

        let i = contents.findIndex(x => x.visible);

        if (i != -1 && i + 1 < contents.length) {
            contents[i + 1].visible = true;
        }
    }

    public ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe);
    }
}